import { createSlice } from "@reduxjs/toolkit";

// userReducer.js
const initialAppState = { 
  isSubcriptionPopUpOpen: false,
  isLoginPopUpOpen: false
 };

const appSlice = createSlice({
  name: 'app',
  initialState: initialAppState,
  reducers: {
    setSubcriptionPopUp: (state, action)=>{
      state.isSubcriptionPopUpOpen=action.payload;
    },
    setLoginPopupOpen: (state, action) => {
      state.isLoginPopUpOpen=action.payload;
    }
  }
})
export const { setSubcriptionPopUp, setLoginPopupOpen } = appSlice.actions;
export default appSlice.reducer;
